import './DataQuiz.scss'
import { closeDataQuizView } from '../quizSlice';
import { divideText } from '../../../../helper/dividerForTextNote';
import Config from '../../../../config/config';

const DataQuiz = (props) => {
    const { dispatch } = props;
   
    const dataQuiz = props.dataQuiz;
   // console.log(dataQuiz);
    const serverPath = Config.serverPath;
   

//CLOSE DATA QUIZ VIEW
const onClickEnd = () => {
    dispatch(closeDataQuizView());
}

const renderAnswers = (dataAnswers) => {
    return (
        dataAnswers.map((element, index) => {
            return (
                <div  className={ element.value !== 100 ? 'bad-answer':'good-answer'} key={index}>
                   <p> {index +1}. {element.text}</p>
                </div>
            )
        })
    )
};


const renderDataQuiz = (data) => {

    
    return (
        data.map((item, index) => {
           // console.log(item.part);
           //const noteName = item.img_path;
           const questionImgName = item.question_img;
           const img_src = questionImgName ? `${serverPath}/api/quizesimg/${item.quiz_id}/${item.question_img}`: null;
          
           
                return (
                    <div className='main-container' key={item.id}>

                    
                        <div className='question-container' >
                            


                            <div className='main-text-container'>{index+1} .
                                <div className='text-container'>
                                {/*<p className='part'>{props.selectedNoteId}.{item.part}</p>*/}

                                    {/*divideText(item.text)*/}
                                    {divideText(item.question.text)}
                                </div>
                            </div>
                            <div className='img-main-container'>
                                {questionImgName ? <img alt="note" src={img_src}/>  : null}

                            </div>   
                            
                            
                        </div>
                        <div>
                            {renderAnswers(item.answers)}
                        </div>    
                    </div>
                )

             
 
        
          })

    )
  
}

        return (
            <div className='DataQuiz'>
                <div className='exit-block'>
                    <button className="exit" onClick={onClickEnd}></button>
                </div>
                {renderDataQuiz(dataQuiz)}
            </div>
        )
  
    

};
export default DataQuiz;